import * as React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { DayPicker, getDefaultClassNames } from "react-day-picker";

import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

function Calendar({
	className,
	classNames,
	showOutsideDays = true,
	weekStartsOn = 1,
	...props
}: React.ComponentProps<typeof DayPicker>) {
	const d = getDefaultClassNames();
	const nav = cn(buttonVariants({ variant: "ghost", size: "icon" }), "size-8 p-0 select-none");
	return (
		<DayPicker
			showOutsideDays={showOutsideDays}
			weekStartsOn={weekStartsOn}
			className={cn("p-1", className)}
			classNames={{
				root: cn("w-fit", d.root),
				months: cn("relative flex flex-col gap-4", d.months),
				month: cn("flex w-full flex-col gap-3", d.month),
				nav: cn("absolute inset-x-0 top-0 flex w-full items-center justify-between", d.nav),
				button_previous: cn(nav, d.button_previous),
				button_next: cn(nav, d.button_next),
				month_caption: cn("flex h-8 items-center justify-center", d.month_caption),
				caption_label: cn("text-sm font-medium select-none", d.caption_label),
				month_grid: cn("w-full border-collapse", d.month_grid),
				weekdays: cn("flex", d.weekdays),
				weekday: cn(
					"text-muted-foreground w-9 flex-1 text-[0.8rem] font-normal select-none",
					d.weekday,
				),
				week: cn("mt-1 flex w-full", d.week),
				day: cn(
					"group/day relative aspect-square h-9 w-9 p-0 text-center text-sm select-none",
					d.day,
				),
				day_button: cn(
					buttonVariants({ variant: "ghost" }),
					"size-9 p-0 font-normal",
					"group-data-[selected=true]/day:bg-primary group-data-[selected=true]/day:text-primary-foreground group-data-[selected=true]/day:hover:bg-primary",
					d.day_button,
				),
				today: cn("bg-accent text-accent-foreground rounded-md", d.today),
				outside: cn("text-muted-foreground opacity-60", d.outside),
				disabled: cn("text-muted-foreground opacity-50", d.disabled),
				hidden: cn("invisible", d.hidden),
				...classNames,
			}}
			components={{
				Chevron: ({ orientation, className: c }) =>
					orientation === "left" ? (
						<ChevronLeftIcon className={cn("size-4", c)} />
					) : (
						<ChevronRightIcon className={cn("size-4", c)} />
					),
			}}
			{...props}
		/>
	);
}

export { Calendar };
